export const environmentProd = {
  priismApptApiEndPoint: "/api/v1",
  priismApiEndPoint: "https://priism.in/priismapp/v1",
  // Razorpay public Key IDs — safe to commit; they ship in the browser bundle by design.
  // Secrets (Key Secret, webhook secret) must live on the backend, never here.
  razorpayKeyId: "rzp_live_5dsWJO6EQJhjw2",
  razorpayKeyIdManoshanti: "rzp_live_SfczOOFjO2Ni9j",
  razorpayKeyIdSthira: "rzp_live_Sfdoeth2p4KIVy"
};
